// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"438":"Login","726":"Index"}[chunkId] + "." + {"438":"3562f763","726":"7664a47f"}[chunkId] + ".css";
};